import React from 'react'
import HeaderSearch from '../HeaderSearch'
import {
    Toolbar as MuiToolbar,
    Container,
    Box,
    Divider,
    styled,
} from '@mui/material'

const StyledToolbar = styled(MuiToolbar)(({ theme }) => ({
    alignItems: 'stretch',
}))

const HeaderContentContainer = styled(Box)({
    display: 'flex',
    minHeight: 'inherit',
    alignItems: 'center',
})

const Header = ({
    mainLogo,
    appLogo,
    rightSideContent,
    genericSearch,
    searchStyleData,
    searchKey,
    handleSearch,
    searchPlaceholder,
    searchComponent,
    mainHeaderContentPadding,
}) => {
    return (
        <Container maxWidth="xl">
            <StyledToolbar disableGutters={false} sx={{ padding: 0 }}>
                <HeaderContentContainer
                    flex="5%"
                    justifyContent="center"
                    position="relative"
                >
                    <Box
                        width="6rem"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        {mainLogo}
                        <Divider
                            orientation="vertical"
                            variant="fullWidth"
                            sx={{
                                position: 'absolute',
                                color: '#e8e8e8',
                                height: '2.6rem',
                                right: 0,
                            }}
                        />
                    </Box>
                </HeaderContentContainer>
                <HeaderContentContainer
                    flex="95%"
                    padding={mainHeaderContentPadding}
                >
                    <Box flex="17%" display="flex">
                        {appLogo}
                    </Box>
                    <Box flex="48%">
                        {genericSearch ? (
                            <HeaderSearch
                                styleData={searchStyleData}
                                value={searchKey}
                                handleSearch={handleSearch}
                                placeholder={searchPlaceholder}
                            />
                        ) : (
                            searchComponent
                        )}
                    </Box>
                    <Box flex="35%" display="flex" justifyContent="flex-end">
                        {rightSideContent.map((item, key) => (
                            <span key={key}>{item}</span>
                        ))}
                    </Box>
                </HeaderContentContainer>
            </StyledToolbar>
        </Container>
    )
}

export default Header
